/**
 * GiftCardStatusPill — ACTIVE / VOIDED (BON-223).
 *
 * A lifecycle state, not a sell-through state, so it gets its own two-tone
 * pill rather than the shared dashboards `StatusPill` tone set — none of that
 * set's tones (sold-out/on-track/at-risk/…) mean anything for a gift card,
 * and reusing one under a borrowed label would be a lie about what the class
 * name means to the next reader. `GiftCardStatus` is a closed ACTIVE|VOIDED
 * pair — there is no third state to treat (EXPIRE is a transaction TYPE, not
 * a card status, and has no bearing on this pill).
 */
import type { GiftCardStatus } from './giftCardTypes';

export function GiftCardStatusPill({ status }: { status: GiftCardStatus }) {
  const voided = status === 'VOIDED';
  return (
    <span
      className="nb-pill"
      style={{
        color: voided ? 'var(--nb-subtle)' : 'var(--nb-primary-2)',
        background: voided ? 'var(--nb-surface)' : 'var(--nb-primary-soft)',
        borderColor: voided ? 'var(--nb-border)' : 'transparent',
      }}
    >
      <i className="nb-pill-dot" style={{ opacity: voided ? 0.5 : 1 }} />
      {voided ? 'Voided' : 'Active'}
    </span>
  );
}
